import { IconButton, styled } from "@mui/material";

export const PasswordVisibilityButton = styled(IconButton)`
  padding: 0;
`;
